import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {FaIcon} from '../../FaIcon';
import {Plus} from '@phosphor-icons/react';
import {BUSummaryRow} from './BUSummaryRow';

const BU_PREVIEW_LIMIT = 5;

export function buildNewControlLineUrl(clientId, clientName) {
    const params = new URLSearchParams({
        client_id: clientId,
        client_name: clientName || '',
        step: '2',
    });
    return `/agency/clients/new/onboarding?${params.toString()}`;
}

export function BUSummaryBox({businessUnits, clientId, clientName, clientAdAccounts, onAddBU, canAddBU, showAll, expandedByDefault, showAccountControls, onAccountsChanged, onControlLineDeleted}) {
    const {t} = useTranslation();

    const activeBUs = (businessUnits || []).filter(
        bu => bu.active === true && bu.is_eventual_and_it_is_finished !== true
    );

    const displayBUs = showAll ? activeBUs : activeBUs.slice(0, BU_PREVIEW_LIMIT);
    const remainingCount = activeBUs.length - displayBUs.length;
    const newControlLineUrl = buildNewControlLineUrl(clientId, clientName);

    return (
        <div className="box bu-summary-box">
            <div className="bu-summary-header">
                <h3 className="bu-summary-title">
                    {t('control_central.bu_summary_title')}
                    <span>({activeBUs.length})</span>
                </h3>
                <div className="bu-summary-header-actions">
                    {canAddBU && (
                        <Link className="cc-action-button -primary -small" to={newControlLineUrl}>
                            <Plus size={14} weight="bold"/>
                            {t('control_central.bu_new_control_line')}
                        </Link>
                    )}
                </div>
            </div>
            {activeBUs.length > 0 ? (
                <>
                    <table className="bu-summary-table">
                        <tbody>
                        {displayBUs.map(bu => (
                            <BUSummaryRow
                                key={bu.id}
                                bu={bu}
                                clientId={clientId}
                                clientName={clientName}
                                clientAdAccounts={clientAdAccounts}
                                defaultOpen={expandedByDefault}
                                showAccountControls={showAccountControls}
                                onAccountsChanged={onAccountsChanged}
                                onControlLineDeleted={onControlLineDeleted}
                            />
                        ))}
                        </tbody>
                    </table>
                    {!showAll && remainingCount > 0 && (
                        <div className="bu-summary-more">
                            <Link to={`/client/${clientId}/monitoring`}>
                                {t('control_central.bu_more_count', {count: remainingCount})}
                            </Link>
                        </div>
                    )}
                </>
            ) : (
                <div className="cc-empty-state">
                    <FaIcon iconName="chart-line"/>
                    <p>{t('control_central.bu_no_budget')}</p>
                    {canAddBU ? (
                        <Link className="btn -alt -small" to={newControlLineUrl}>
                            <FaIcon iconName="plus"/>
                            {t('control_central.bu_empty_cta')}
                        </Link>
                    ) : onAddBU ? (
                        <button className="btn -alt -small" onClick={onAddBU}>
                            <FaIcon iconName="plus"/>
                            {t('control_central.bu_empty_cta')}
                        </button>
                    ) : null}
                </div>
            )}
        </div>
    );
}
